/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ClaimPortalRouteImport } from './routes/claim-portal'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as AuthMicrosoftRouteImport } from './routes/auth.microsoft'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedUploadScheduleRouteImport } from './routes/_authenticated/upload-schedule'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedQuickStartRouteImport } from './routes/_authenticated/quick-start'
import { Route as AuthenticatedOrganizationRouteImport } from './routes/_authenticated/organization'
import { Route as AuthenticatedImportRouteImport } from './routes/_authenticated/import'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar'
import { Route as AuthenticatedAssistantRouteImport } from './routes/_authenticated/assistant'
import { Route as AuthenticatedRolesIndexRouteImport } from './routes/_authenticated/roles/index'
import { Route as AuthenticatedProposalsIndexRouteImport } from './routes/_authenticated/proposals/index'
import { Route as AuthenticatedPatientsIndexRouteImport } from './routes/_authenticated/patients/index'
import { Route as AuthenticatedImagingIndexRouteImport } from './routes/_authenticated/imaging/index'
import { Route as AuthenticatedEncountersIndexRouteImport } from './routes/_authenticated/encounters/index'
import { Route as AuthenticatedEligibilityIndexRouteImport } from './routes/_authenticated/eligibility/index'
import { Route as AuthenticatedDocumentsIndexRouteImport } from './routes/_authenticated/documents/index'
import { Route as AuthenticatedClaimsIndexRouteImport } from './routes/_authenticated/claims/index'
import { Route as AuthenticatedRolesRoleIdRouteImport } from './routes/_authenticated/roles/$roleId'
import { Route as AuthenticatedPatientsNewRouteImport } from './routes/_authenticated/patients/new'
import { Route as AuthenticatedPatientsPatientIdRouteImport } from './routes/_authenticated/patients/$patientId'
import { Route as AuthenticatedImagingStudyIdRouteImport } from './routes/_authenticated/imaging/$studyId'
import { Route as AuthenticatedEncountersNewRouteImport } from './routes/_authenticated/encounters/new'
import { Route as AuthenticatedEncountersListRouteImport } from './routes/_authenticated/encounters/list'
import { Route as AuthenticatedEncountersEncounterIdRouteImport } from './routes/_authenticated/encounters/$encounterId'
import { Route as AuthenticatedDocumentsListRouteImport } from './routes/_authenticated/documents/list'

const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ClaimPortalRoute = ClaimPortalRouteImport.update({
  id: '/claim-portal',
  path: '/claim-portal',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMicrosoftRoute = AuthMicrosoftRouteImport.update({
  id: '/auth/microsoft',
  path: '/auth/microsoft',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUploadScheduleRoute =
  AuthenticatedUploadScheduleRouteImport.update({
    id: '/upload-schedule',
    path: '/upload-schedule',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedQuickStartRoute = AuthenticatedQuickStartRouteImport.update({
  id: '/quick-start',
  path: '/quick-start',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrganizationRoute =
  AuthenticatedOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedImportRoute = AuthenticatedImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCalendarRoute = AuthenticatedCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAssistantRoute = AuthenticatedAssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProposalsIndexRoute =
  AuthenticatedProposalsIndexRouteImport.update({
    id: '/proposals/',
    path: '/proposals/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsIndexRoute =
  AuthenticatedPatientsIndexRouteImport.update({
    id: '/patients/',
    path: '/patients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedImagingIndexRoute =
  AuthenticatedImagingIndexRouteImport.update({
    id: '/imaging/',
    path: '/imaging/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEncountersIndexRoute =
  AuthenticatedEncountersIndexRouteImport.update({
    id: '/encounters/',
    path: '/encounters/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEligibilityIndexRoute =
  AuthenticatedEligibilityIndexRouteImport.update({
    id: '/eligibility/',
    path: '/eligibility/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocumentsIndexRoute =
  AuthenticatedDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClaimsIndexRoute =
  AuthenticatedClaimsIndexRouteImport.update({
    id: '/claims/',
    path: '/claims/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesRoleIdRoute =
  AuthenticatedRolesRoleIdRouteImport.update({
    id: '/roles/$roleId',
    path: '/roles/$roleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsNewRoute =
  AuthenticatedPatientsNewRouteImport.update({
    id: '/patients/new',
    path: '/patients/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPatientsPatientIdRoute =
  AuthenticatedPatientsPatientIdRouteImport.update({
    id: '/patients/$patientId',
    path: '/patients/$patientId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedImagingStudyIdRoute =
  AuthenticatedImagingStudyIdRouteImport.update({
    id: '/imaging/$studyId',
    path: '/imaging/$studyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEncountersNewRoute =
  AuthenticatedEncountersNewRouteImport.update({
    id: '/encounters/new',
    path: '/encounters/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEncountersListRoute =
  AuthenticatedEncountersListRouteImport.update({
    id: '/encounters/list',
    path: '/encounters/list',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEncountersEncounterIdRoute =
  AuthenticatedEncountersEncounterIdRouteImport.update({
    id: '/encounters/$encounterId',
    path: '/encounters/$encounterId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocumentsListRoute =
  AuthenticatedDocumentsListRouteImport.update({
    id: '/documents/list',
    path: '/documents/list',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/claim-portal': typeof ClaimPortalRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/assistant': typeof AuthenticatedAssistantRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/import': typeof AuthenticatedImportRoute
  '/organization': typeof AuthenticatedOrganizationRoute
  '/quick-start': typeof AuthenticatedQuickStartRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/upload-schedule': typeof AuthenticatedUploadScheduleRoute
  '/users': typeof AuthenticatedUsersRoute
  '/auth/microsoft': typeof AuthMicrosoftRoute
  '/s/$token': typeof STokenRoute
  '/documents/list': typeof AuthenticatedDocumentsListRoute
  '/encounters/$encounterId': typeof AuthenticatedEncountersEncounterIdRoute
  '/encounters/list': typeof AuthenticatedEncountersListRoute
  '/encounters/new': typeof AuthenticatedEncountersNewRoute
  '/imaging/$studyId': typeof AuthenticatedImagingStudyIdRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/patients/new': typeof AuthenticatedPatientsNewRoute
  '/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/claims': typeof AuthenticatedClaimsIndexRoute
  '/documents': typeof AuthenticatedDocumentsIndexRoute
  '/eligibility': typeof AuthenticatedEligibilityIndexRoute
  '/encounters': typeof AuthenticatedEncountersIndexRoute
  '/imaging': typeof AuthenticatedImagingIndexRoute
  '/patients': typeof AuthenticatedPatientsIndexRoute
  '/proposals': typeof AuthenticatedProposalsIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/claim-portal': typeof ClaimPortalRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/assistant': typeof AuthenticatedAssistantRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/import': typeof AuthenticatedImportRoute
  '/organization': typeof AuthenticatedOrganizationRoute
  '/quick-start': typeof AuthenticatedQuickStartRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/upload-schedule': typeof AuthenticatedUploadScheduleRoute
  '/users': typeof AuthenticatedUsersRoute
  '/auth/microsoft': typeof AuthMicrosoftRoute
  '/s/$token': typeof STokenRoute
  '/documents/list': typeof AuthenticatedDocumentsListRoute
  '/encounters/$encounterId': typeof AuthenticatedEncountersEncounterIdRoute
  '/encounters/list': typeof AuthenticatedEncountersListRoute
  '/encounters/new': typeof AuthenticatedEncountersNewRoute
  '/imaging/$studyId': typeof AuthenticatedImagingStudyIdRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/patients/new': typeof AuthenticatedPatientsNewRoute
  '/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/claims': typeof AuthenticatedClaimsIndexRoute
  '/documents': typeof AuthenticatedDocumentsIndexRoute
  '/eligibility': typeof AuthenticatedEligibilityIndexRoute
  '/encounters': typeof AuthenticatedEncountersIndexRoute
  '/imaging': typeof AuthenticatedImagingIndexRoute
  '/patients': typeof AuthenticatedPatientsIndexRoute
  '/proposals': typeof AuthenticatedProposalsIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/claim-portal': typeof ClaimPortalRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/_authenticated/assistant': typeof AuthenticatedAssistantRoute
  '/_authenticated/calendar': typeof AuthenticatedCalendarRoute
  '/_authenticated/import': typeof AuthenticatedImportRoute
  '/_authenticated/organization': typeof AuthenticatedOrganizationRoute
  '/_authenticated/quick-start': typeof AuthenticatedQuickStartRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/upload-schedule': typeof AuthenticatedUploadScheduleRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/auth/microsoft': typeof AuthMicrosoftRoute
  '/s/$token': typeof STokenRoute
  '/_authenticated/documents/list': typeof AuthenticatedDocumentsListRoute
  '/_authenticated/encounters/$encounterId': typeof AuthenticatedEncountersEncounterIdRoute
  '/_authenticated/encounters/list': typeof AuthenticatedEncountersListRoute
  '/_authenticated/encounters/new': typeof AuthenticatedEncountersNewRoute
  '/_authenticated/imaging/$studyId': typeof AuthenticatedImagingStudyIdRoute
  '/_authenticated/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/_authenticated/patients/new': typeof AuthenticatedPatientsNewRoute
  '/_authenticated/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/_authenticated/claims/': typeof AuthenticatedClaimsIndexRoute
  '/_authenticated/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/_authenticated/eligibility/': typeof AuthenticatedEligibilityIndexRoute
  '/_authenticated/encounters/': typeof AuthenticatedEncountersIndexRoute
  '/_authenticated/imaging/': typeof AuthenticatedImagingIndexRoute
  '/_authenticated/patients/': typeof AuthenticatedPatientsIndexRoute
  '/_authenticated/proposals/': typeof AuthenticatedProposalsIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/claim-portal'
    | '/login'
    | '/set-password'
    | '/assistant'
    | '/calendar'
    | '/import'
    | '/organization'
    | '/quick-start'
    | '/settings'
    | '/upload-schedule'
    | '/users'
    | '/auth/microsoft'
    | '/s/$token'
    | '/documents/list'
    | '/encounters/$encounterId'
    | '/encounters/list'
    | '/encounters/new'
    | '/imaging/$studyId'
    | '/patients/$patientId'
    | '/patients/new'
    | '/roles/$roleId'
    | '/claims'
    | '/documents'
    | '/eligibility'
    | '/encounters'
    | '/imaging'
    | '/patients'
    | '/proposals'
    | '/roles'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/claim-portal'
    | '/login'
    | '/set-password'
    | '/assistant'
    | '/calendar'
    | '/import'
    | '/organization'
    | '/quick-start'
    | '/settings'
    | '/upload-schedule'
    | '/users'
    | '/auth/microsoft'
    | '/s/$token'
    | '/documents/list'
    | '/encounters/$encounterId'
    | '/encounters/list'
    | '/encounters/new'
    | '/imaging/$studyId'
    | '/patients/$patientId'
    | '/patients/new'
    | '/roles/$roleId'
    | '/claims'
    | '/documents'
    | '/eligibility'
    | '/encounters'
    | '/imaging'
    | '/patients'
    | '/proposals'
    | '/roles'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/claim-portal'
    | '/login'
    | '/set-password'
    | '/_authenticated/assistant'
    | '/_authenticated/calendar'
    | '/_authenticated/import'
    | '/_authenticated/organization'
    | '/_authenticated/quick-start'
    | '/_authenticated/settings'
    | '/_authenticated/upload-schedule'
    | '/_authenticated/users'
    | '/auth/microsoft'
    | '/s/$token'
    | '/_authenticated/documents/list'
    | '/_authenticated/encounters/$encounterId'
    | '/_authenticated/encounters/list'
    | '/_authenticated/encounters/new'
    | '/_authenticated/imaging/$studyId'
    | '/_authenticated/patients/$patientId'
    | '/_authenticated/patients/new'
    | '/_authenticated/roles/$roleId'
    | '/_authenticated/claims/'
    | '/_authenticated/documents/'
    | '/_authenticated/eligibility/'
    | '/_authenticated/encounters/'
    | '/_authenticated/imaging/'
    | '/_authenticated/patients/'
    | '/_authenticated/proposals/'
    | '/_authenticated/roles/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ClaimPortalRoute: typeof ClaimPortalRoute
  LoginRoute: typeof LoginRoute
  SetPasswordRoute: typeof SetPasswordRoute
  AuthMicrosoftRoute: typeof AuthMicrosoftRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/claim-portal': {
      id: '/claim-portal'
      path: '/claim-portal'
      fullPath: '/claim-portal'
      preLoaderRoute: typeof ClaimPortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/microsoft': {
      id: '/auth/microsoft'
      path: '/auth/microsoft'
      fullPath: '/auth/microsoft'
      preLoaderRoute: typeof AuthMicrosoftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/upload-schedule': {
      id: '/_authenticated/upload-schedule'
      path: '/upload-schedule'
      fullPath: '/upload-schedule'
      preLoaderRoute: typeof AuthenticatedUploadScheduleRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quick-start': {
      id: '/_authenticated/quick-start'
      path: '/quick-start'
      fullPath: '/quick-start'
      preLoaderRoute: typeof AuthenticatedQuickStartRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organization': {
      id: '/_authenticated/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AuthenticatedOrganizationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/import': {
      id: '/_authenticated/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof AuthenticatedImportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar': {
      id: '/_authenticated/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthenticatedCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assistant': {
      id: '/_authenticated/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AuthenticatedAssistantRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AuthenticatedRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/proposals/': {
      id: '/_authenticated/proposals/'
      path: '/proposals'
      fullPath: '/proposals'
      preLoaderRoute: typeof AuthenticatedProposalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/': {
      id: '/_authenticated/patients/'
      path: '/patients'
      fullPath: '/patients'
      preLoaderRoute: typeof AuthenticatedPatientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/imaging/': {
      id: '/_authenticated/imaging/'
      path: '/imaging'
      fullPath: '/imaging'
      preLoaderRoute: typeof AuthenticatedImagingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/encounters/': {
      id: '/_authenticated/encounters/'
      path: '/encounters'
      fullPath: '/encounters'
      preLoaderRoute: typeof AuthenticatedEncountersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/eligibility/': {
      id: '/_authenticated/eligibility/'
      path: '/eligibility'
      fullPath: '/eligibility'
      preLoaderRoute: typeof AuthenticatedEligibilityIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents/': {
      id: '/_authenticated/documents/'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/claims/': {
      id: '/_authenticated/claims/'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof AuthenticatedClaimsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles/$roleId': {
      id: '/_authenticated/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/new': {
      id: '/_authenticated/patients/new'
      path: '/patients/new'
      fullPath: '/patients/new'
      preLoaderRoute: typeof AuthenticatedPatientsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/patients/$patientId': {
      id: '/_authenticated/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof AuthenticatedPatientsPatientIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/imaging/$studyId': {
      id: '/_authenticated/imaging/$studyId'
      path: '/imaging/$studyId'
      fullPath: '/imaging/$studyId'
      preLoaderRoute: typeof AuthenticatedImagingStudyIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/encounters/new': {
      id: '/_authenticated/encounters/new'
      path: '/encounters/new'
      fullPath: '/encounters/new'
      preLoaderRoute: typeof AuthenticatedEncountersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/encounters/list': {
      id: '/_authenticated/encounters/list'
      path: '/encounters/list'
      fullPath: '/encounters/list'
      preLoaderRoute: typeof AuthenticatedEncountersListRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/encounters/$encounterId': {
      id: '/_authenticated/encounters/$encounterId'
      path: '/encounters/$encounterId'
      fullPath: '/encounters/$encounterId'
      preLoaderRoute: typeof AuthenticatedEncountersEncounterIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents/list': {
      id: '/_authenticated/documents/list'
      path: '/documents/list'
      fullPath: '/documents/list'
      preLoaderRoute: typeof AuthenticatedDocumentsListRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAssistantRoute: typeof AuthenticatedAssistantRoute
  AuthenticatedCalendarRoute: typeof AuthenticatedCalendarRoute
  AuthenticatedImportRoute: typeof AuthenticatedImportRoute
  AuthenticatedOrganizationRoute: typeof AuthenticatedOrganizationRoute
  AuthenticatedQuickStartRoute: typeof AuthenticatedQuickStartRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedUploadScheduleRoute: typeof AuthenticatedUploadScheduleRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedDocumentsListRoute: typeof AuthenticatedDocumentsListRoute
  AuthenticatedEncountersEncounterIdRoute: typeof AuthenticatedEncountersEncounterIdRoute
  AuthenticatedEncountersListRoute: typeof AuthenticatedEncountersListRoute
  AuthenticatedEncountersNewRoute: typeof AuthenticatedEncountersNewRoute
  AuthenticatedImagingStudyIdRoute: typeof AuthenticatedImagingStudyIdRoute
  AuthenticatedPatientsPatientIdRoute: typeof AuthenticatedPatientsPatientIdRoute
  AuthenticatedPatientsNewRoute: typeof AuthenticatedPatientsNewRoute
  AuthenticatedRolesRoleIdRoute: typeof AuthenticatedRolesRoleIdRoute
  AuthenticatedClaimsIndexRoute: typeof AuthenticatedClaimsIndexRoute
  AuthenticatedDocumentsIndexRoute: typeof AuthenticatedDocumentsIndexRoute
  AuthenticatedEligibilityIndexRoute: typeof AuthenticatedEligibilityIndexRoute
  AuthenticatedEncountersIndexRoute: typeof AuthenticatedEncountersIndexRoute
  AuthenticatedImagingIndexRoute: typeof AuthenticatedImagingIndexRoute
  AuthenticatedPatientsIndexRoute: typeof AuthenticatedPatientsIndexRoute
  AuthenticatedProposalsIndexRoute: typeof AuthenticatedProposalsIndexRoute
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAssistantRoute: AuthenticatedAssistantRoute,
  AuthenticatedCalendarRoute: AuthenticatedCalendarRoute,
  AuthenticatedImportRoute: AuthenticatedImportRoute,
  AuthenticatedOrganizationRoute: AuthenticatedOrganizationRoute,
  AuthenticatedQuickStartRoute: AuthenticatedQuickStartRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedUploadScheduleRoute: AuthenticatedUploadScheduleRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedDocumentsListRoute: AuthenticatedDocumentsListRoute,
  AuthenticatedEncountersEncounterIdRoute:
    AuthenticatedEncountersEncounterIdRoute,
  AuthenticatedEncountersListRoute: AuthenticatedEncountersListRoute,
  AuthenticatedEncountersNewRoute: AuthenticatedEncountersNewRoute,
  AuthenticatedImagingStudyIdRoute: AuthenticatedImagingStudyIdRoute,
  AuthenticatedPatientsPatientIdRoute: AuthenticatedPatientsPatientIdRoute,
  AuthenticatedPatientsNewRoute: AuthenticatedPatientsNewRoute,
  AuthenticatedRolesRoleIdRoute: AuthenticatedRolesRoleIdRoute,
  AuthenticatedClaimsIndexRoute: AuthenticatedClaimsIndexRoute,
  AuthenticatedDocumentsIndexRoute: AuthenticatedDocumentsIndexRoute,
  AuthenticatedEligibilityIndexRoute: AuthenticatedEligibilityIndexRoute,
  AuthenticatedEncountersIndexRoute: AuthenticatedEncountersIndexRoute,
  AuthenticatedImagingIndexRoute: AuthenticatedImagingIndexRoute,
  AuthenticatedPatientsIndexRoute: AuthenticatedPatientsIndexRoute,
  AuthenticatedProposalsIndexRoute: AuthenticatedProposalsIndexRoute,
  AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ClaimPortalRoute: ClaimPortalRoute,
  LoginRoute: LoginRoute,
  SetPasswordRoute: SetPasswordRoute,
  AuthMicrosoftRoute: AuthMicrosoftRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
